import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PickListModule, TooltipModule} from 'primeng/primeng';
import {ToastModule} from 'primeng/toast';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import {ToastNoAnimation, ToastrModule} from 'ngx-toastr';
import {RouterModule} from '@angular/router';
import {RoundOneComponent} from './round-one/round-one.component';
import {PracticeRoundComponent} from './practice-round/practice-round.component';
import {RoundTwoComponent} from './round-two/round-two.component';
import {DataTablesModule} from 'angular-datatables';
import {NguiAutoCompleteModule} from '@ngui/auto-complete';
import { RoundThreeComponent } from './round-three/round-three.component';
import { BiddingRoundTwoComponent } from './bidding-round-two/bidding-round-two.component';
import {RoundFourComponent} from './round-four/round-four.component';

@NgModule({
    declarations: [
        PracticeRoundComponent,
        RoundOneComponent,
        RoundTwoComponent,
        RoundThreeComponent,
        RoundFourComponent,
        BiddingRoundTwoComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        NgbModalModule,
        FormsModule,
        PickListModule,
        TooltipModule,
        ToastModule,
        RouterModule,
        NguiAutoCompleteModule,
        ToastrModule.forRoot({
            toastComponent: ToastNoAnimation,
        }),
        DataTablesModule
    ]
})
export class BiddingRoundsModule {
}
